<template>
	<span class="c-culture">
		<a @click="setPopupMode('language')" class="c-culture__toggle">
			<DsIcon icon-name="globe" size="xs" />
			<span class="c-culture__toggle-text">
				{{ vm.BaseViewModel.CurrentCountryName }}
			</span>
		</a>

		<DsModal
			@close-modal="setPopupMode('none')"
			:close-label="vm.BaseViewModel.CloseModalLabel ?? 'Close'"
			:isOpen="show === 'country'"
			overflow="container"
			size="md"
		>
			<CountrySwitcher
				:countryLabelText="vmc.BaseViewModel.CountryLabelText"
				:countryList="vmc.BaseViewModel.CountryList"
				:description="vmc.BaseViewModel.Description"
				:headline="vmc.BaseViewModel.Headline"
				:lang="lang"
				:langUrl="langUrl"
				:selectCountryLabelText="vmc.BaseViewModel.CountryLabelText"
				:setPopupMode="setPopupMode"
				:show="show"
			/>

			<template #actions>
				<DsButton
					variant="primary"
					class="c-culture__submit"
					@click="submitLanguage"
				>
					{{ vmc.BaseViewModel.ContinueButtonText }}
				</DsButton>
			</template>
		</DsModal>

		<DsModal
			@close-modal="setPopupMode('none')"
			:close-label="vm.BaseViewModel.CloseModalLabel ?? 'Close'"
			:isOpen="show === 'language'"
			overflow="container"
			size="md"
		>
			<CountrySites
				:allTabEnabled="vm.BaseViewModel.AllTabEnabled"
				:allTabLabel="vm.BaseViewModel.AllTabLabel"
				:countryList="vm.BaseViewModel.CountryList ?? []"
				:countryRegionList="vm.BaseViewModel.CountryRegionList ?? []"
				:currentCountryName="vm.BaseViewModel.CurrentCountryName"
				:headline="vm.BaseViewModel.Headline"
				:lang="lang"
				:langUrl="langUrl"
				:setPopupMode="setPopupMode"
				:show="show"
			/>
		</DsModal>
	</span>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { DsButton, DsIcon, DsModal } from '@coloplast/design-system';
import CountrySwitcher from './CountrySwitcher.vue';
import CountrySites from './CountrySites.vue';
import { useCultureNavigation } from './useCultureNavigation';
import { type Vm, type Vmc } from './types';

const props = defineProps<{
	vm: Vm;
	vmc: Vmc;
}>();

const show = ref<string>('none');
const lang = ref<string>(props.vm.BaseViewModel.lang);
const langUrl = ref<string>(props.vm.BaseViewModel.langUrl);

const { setCultureCookie } = useCultureNavigation();

const setPopupMode = (name: string) => {
	show.value = name;
};

const submitLanguage = () => {
	setCultureCookie(lang.value);
	setPopupMode('none');
	window.location.assign(langUrl.value);
};

const setCultureSelectorSwitcher = () => {
	const selectors = document.querySelectorAll('[data-culture-selector-item]');

	selectors.forEach((selector) => {
		const selectorInner = selector.querySelector(
			'span.c-nav-service__text'
		);
		if (selectorInner && props.vm.BaseViewModel.CurrentCountryName.length) {
			selectorInner.textContent =
				props.vm.BaseViewModel.CurrentCountryName;
		}

		selector.addEventListener('click', (ev) => {
			ev.preventDefault();
			setPopupMode('language');
		});
	});
};

onMounted(() => {
	const selected = props.vmc.BaseViewModel.CountryList.find(
		(c) => c.IsSelected
	);

	if (selected) {
		lang.value = selected.Name;
		langUrl.value = selected.Url;
		setPopupMode('country');
	}

	setCultureSelectorSwitcher();
});
</script>
